<script lang="ts">
  import { getTimerStyle, styleToString } from "@shared/common/node/style";
  import type { ITimerNode, PartialNode } from "@shared/common/node/type";
  import type { ICampaignSetting } from "@shared/common/types/campaign";
  import type { ITimeData } from "@shared/common/types/data-source";
  import { createTimeData } from "@shared/common/utils/data-source";
  import { stringTemplateHelper } from "@shared/common/utils/string-template-helper";
  import {
    formatsToContent,
    getCountdownTimeLeft,
    getTimeLeftByUnits,
    getTimeUnitsFromContent,
    setRAFInterval,
  } from "@shared/common/utils/timer";
  import { getContext, onDestroy } from "svelte";
  import detectReaction from "../../actions/detect-reaction";
  import { getCurrentDocumentNode, getStore } from "../../context";

  const campaignSetting = getContext<ICampaignSetting>("campaignSetting");

  const { dataMap, reactionEventListener, t } = getStore();

  const documentNode = getCurrentDocumentNode();

  export let node: PartialNode<ITimerNode>;

  let content =
    node.timer?.format === "custom"
      ? node.content
      : formatsToContent(node.timer?.format ?? "");

  let timeData: ITimeData = createTimeData({
    data:
      !!node.timer && content !== undefined
        ? getTimeLeftByUnits(
            getCountdownTimeLeft(node.timer),
            getTimeUnitsFromContent(content)
          )
        : { dd: "0", d: "0", h: "0", m: "0", s: "0" },
  });
  let timerEnd = false;

  let clearInterval = () => {};

  if (
    node.timer &&
    (node.timer.type === "COUNTDOWN" || node.timer.type === "COUNTDOWN_REPEAT")
  ) {
    const timeUnits = getTimeUnitsFromContent(content ?? "");
    const timeLeft = getCountdownTimeLeft(node.timer);
    if (timeLeft <= 0) {
      // 이미 종료된 카운트다운이라면 바로 종료 동작 실행
      clearInterval();
      timerEnd = true;
      if (node.timer?.endAction?.type === "SHOW_MESSAGE") {
        content = node.timer?.endAction.message;
      }
    } else {
      // 카운트다운 시작
      clearInterval = setRAFInterval(() => {
        if (!node.timer) {
          clearInterval();
          return;
        }

        const timeLeft = getCountdownTimeLeft(node.timer);
        timeData = {
          ...timeData,
          data: getTimeLeftByUnits(timeLeft, timeUnits),
        };

        if (timeLeft <= 0) {
          clearInterval();
          timerEnd = true;
          if (node.timer?.endAction?.type === "SHOW_MESSAGE") {
            content = node.timer?.endAction.message;
          }
        }
      }, 1000);
    }
  }

  onDestroy(() => {
    clearInterval();
  });
</script>

<div
  use:detectReaction={{
    node,
    onAction: reactionEventListener,
    documentNode,
  }}
  style={styleToString({
    ...getTimerStyle(node, campaignSetting.language),
    ...(timerEnd && node.timer?.endAction?.type === "HIDE" && { opacity: 0 }),
  })}
>
  <!-- eslint-disable-next-line svelte/no-at-html-tags -->
  {@html stringTemplateHelper({ mode: "VIEW", t: $t }).render(content || "", {
    ...$dataMap,
    time: timeData,
  })}
</div>
